module.exports = __webpack_public_path__ + "static/media/switz_feb_2025.12edd07b.webp";